/* eslint-disable import/prefer-default-export */
import ProjectsDirectoryRequests from '../../server/projectsDirectory';
import { addLoading, removeLoading } from './loading';

export const getListProjectsDirectory = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.getListProjectsDirectory(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const searchPaginatedContactList = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.searchPaginatedContactList(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvProjectsDirectory = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.getCsvProjectsDirectory();
  } finally {
    dispatch(removeLoading());
  }
};

export const getContactReportCsv = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.getContactReportCsv();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCsvProjectsDirectory = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.uploadCsvProjectsDirectory(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadProjectsDirectory = projectsDirectoryParameter => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.uploadProjectsDirectory(projectsDirectoryParameter);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteProjectsDirectory = projectsDirectoryId => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProjectsDirectoryRequests.deleteProjectsDirectory(projectsDirectoryId);
  } finally {
    dispatch(removeLoading());
  }
};
